import {InvoiceEventTypeEnum} from "./InvoiceEvent";

export enum InvoiceEventCategory {
	All = "All",
	Payments = "Payments",
	Updates = "Updates",
	Notes = "Notes"
}

/**
 * Invoice event type object model.
 */
export default class InvoiceEventTypeObject {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to InvoiceEventTypeObject.
	 * @param {string} string
	 * @return {InvoiceEventTypeObject}
	 */
	public static fromString(string: string): InvoiceEventTypeObject {
		return new InvoiceEventTypeObject(string)
	}

	/**
	 * Get InvoiceEventTypeObjects for given category.
	 * @param {string} filter Category key.
	 * @return {InvoiceEventTypeObject[]} List of InvoiceEventTypeObjects for given category.
	 */
	public static getTypesForCategory(filter: string): InvoiceEventTypeObject[] {
		if (filter === InvoiceEventCategory.All) {
			return InvoiceEventTypeObject.getAllTypes();
		}
		if (filter === InvoiceEventCategory.Payments) {
			return InvoiceEventTypeObject.getPaymentTypes();
		}
		if (filter === InvoiceEventCategory.Updates) {
			return InvoiceEventTypeObject.getUpdateTypes();
		}
		if (filter === InvoiceEventCategory.Notes) {
			return InvoiceEventTypeObject.getNoteTypes();
		}
		return null;
	}

	public static getAllTypes(): InvoiceEventTypeObject[] {
		const result: InvoiceEventTypeObject[] = [];
		for (let key in InvoiceEventTypeEnum) {
			result.push(InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum[key]));
		}
		return result;
	}

	public static getPaymentTypes(): InvoiceEventTypeObject[] {
		return [
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.Payment),
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoicePaid)
		];
	}

	public static getUpdateTypes(): InvoiceEventTypeObject[] {
		return [
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoicePaid),
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoiceSent),
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoiceUpdated),
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoiceApproved),
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.InvoiceCreated)
		];
	}

	public static getNoteTypes(): InvoiceEventTypeObject[] {
		return [
			InvoiceEventTypeObject.fromString(InvoiceEventTypeEnum.Note)
		];
	}
}
